import { getProductScope } from '@discover-frontend/utils';
import { callApi } from './api';
import { getMyId, getTokens } from '../utils/AuthHelperMethods';

export const fetchCompaniesApi = (queryString) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/companies${queryString}`,
    mock: false,
  });

export const fetchCompanyApi = (companyId) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/companies/${companyId}?scope=${getProductScope()}`,
    mock: false,
  });

export const fetchUsersApi = (queryString) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/users${queryString}`,
    mock: false,
  });

export const fetchCompanyUsersApi = (id, queryString) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/companies/${id}/users${queryString}`,
    mock: false,
  });

export const fetchFusionsApi = (queryString) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/catalog/fusions${queryString}`,
    mock: false,
  });

export const fetchAudienceBuildersApi = (queryString) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/catalog/audience_builders${queryString}`,
    mock: false,
  });

export const fetchGetNotificationsApi = (queryString) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/users/${getMyId()}/notifications${queryString}`,
    mock: false,
  });

export const fetchDeleteNotificationApi = (notificationId) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'DELETE',
    endpoint: `/users/${getMyId()}/notifications/${notificationId}`,
    mock: false,
  });

export const fetchMarkNotificationAsReadApi = (notificationId) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'PATCH',
    endpoint: `/users/${getMyId()}/notifications/${notificationId}`,
    mock: false,
  });

export const fetchMarkAllNotificationsAsReadApi = () =>
  callApi({
    api: 'ACCOUNTS',
    method: 'PATCH',
    endpoint: `/users/${getMyId()}/notifications/all`,
    mock: false,
  });

export const fetchIgnoreTwitterTokenApi = () => {
  const { idToken } = getTokens();
  return callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/users/twitter/ignore_token_request?idtoken=${idToken}`,
    mock: false,
  });
};

export const fetchGenerateTwitterUrlApi = () =>
  callApi({
    api: 'ACCOUNTS',
    method: 'GET',
    endpoint: `/users/twitter/generate_url`,
    mock: false,
    redirect: 'error',
  });

export const fetchUpdateMySettingsApi = (body) =>
  callApi({
    api: 'ACCOUNTS',
    method: 'POST',
    endpoint: `/users/${getMyId()}/settings`,
    mock: false,
    body,
    no_content: true,
  });
